import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FetchCountries } from './country.actions';
import { CountryStateModel } from './model/country-state-model';

const DEFAULT_STATE: CountryStateModel = {
  countries: []
};

@State<CountryStateModel>({
  name: 'country',
  defaults: DEFAULT_STATE
})
@Injectable()
export class CountryState {
  constructor(private http: HttpClient) {}

  @Selector()
  static countries(state: CountryStateModel): string[] {
    return state.countries;
  }

  @Action(FetchCountries)
  fetchCountries(ctx: StateContext<CountryStateModel>, { refetchIfAlreadyFetched }: FetchCountries): Observable<unknown> {
    if (!refetchIfAlreadyFetched && ctx.getState().countries.length > 0) {
      return of(null);
    } else {
      return this.http.get<string[]>(PLATFORM_ENVIRONMENT.apiUrl + '/billingInformation/countries').pipe(tap(countries => ctx.patchState({ countries })));
    }
  }
}
